const styles = theme => ({
  root: {
    width: '96.4%',
    height: '380px',
    margin: '30px',
    marginTop: '0px',
    paddingTop: '10px',
    backgroundColor: '#fff',
    overflow: 'hidden'
  },
  tableTitle: {
    color: '#fff',
    margin: '30px',
    marginBottom: '0px',
    marginTop: '0px'
  }
});

export default styles;


// WEBPACK FOOTER //
// ./src/main/components/styles/ProblemsStatsStyles.js